import firebase from 'firebase';
import { ProductType } from '../types';
import { CATALOG_GROUPS } from '../store/data';

const collection = '/store/origin/products';
const db = firebase.firestore();

firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
});

firebase
  .firestore()
  .enablePersistence()
  .catch(function(err) {
    if (err.code == 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code == 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });

const processResponseSnapshot = (snapshot: any) => {
  const results: ProductType[] = [];
  snapshot.forEach((doc: any) => {
    results.push({ ...doc.data(), id: doc.id } as ProductType);
  });
  return results;
};

export const getProducts = async (searchString = '', limit = 10) => {
  const results: ProductType[] = [];

  const products = await db
    .collection(collection)
    // .where('title', '>=', searchString.toLowerCase())
    .where('author', '>=', searchString)
    .where('author', '<=', searchString + 'z')
    .orderBy('author')
    .limit(limit)
    // .startAfter('')
    .get()
    .then(processResponseSnapshot);

  return products;
};

const MAIN_GENRES_MAP: Record<string, number> = {
  disco: 2,
  pop: 4,
  electronic: 3,
  rock: 1,
};

const getProductsByLast = async () => {
  const products = await db
    .collection(collection)
    .orderBy('createdate', 'desc')
    .limit(20)
    .get()
    .then(processResponseSnapshot);
  return products;
};

export const getProductsByGroup = async (group: string, limit = 100) => {
  if (group === 'new') return getProductsByLast();

  const products = await db
    .collection(collection)
    .where('category', '==', MAIN_GENRES_MAP[group])
    .limit(limit)
    .get()
    .then(processResponseSnapshot);

  return products;
};

export const getProductsMainPage = async () => {
  const previewLimit = 4;
  // eslint-disable-next-line no-undef
  const [disco, pop, electronic, rock] = await Promise.all([
    getProductsByGroup('disco', previewLimit),
    getProductsByGroup('pop', previewLimit),
    getProductsByGroup('electronic', previewLimit),
    getProductsByGroup('rock', previewLimit),
  ]);

  const results: Record<string, ProductType[]> = {
    disco,
    pop,
    electronic,
    rock,
  };

  results.new = [...results.rock];

  return results;
};

// db.collection("cities").where("state", "==", "CA")
// .onSnapshot({ includeMetadataChanges: true }, function(snapshot) {
//   snapshot.docChanges().forEach(function(change) {
//     if (change.type === "added") {
//       console.log("New city: ", change.doc.data());
//     }
//
//     var source = snapshot.metadata.fromCache ? "local cache" : "server";
//     console.log("Data came from " + source);
//   });
// });
